import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { func, shape, string } from 'prop-types';
import { langType, withLang } from '../../../i18n';
import { surveyOptionsType } from '../../../constants/types';
import styles from './surveyQuestions.module.css';
import PreviewLanguageSelector from '../../Preview/PreviewLanguageSelector';
import { getExtraSurveyPart, getSurveySchema } from '../../../api';
import SchemaPartQuestionsPreview from '../../Preview/SchemaPartPreview/QuestionsPreview';
import { addErrorMessageAction, setTaskFulfilled, setTaskPending } from '../../../actions';
import withRouter from '../../WithRouter';
import { withPreviousLocation } from '../../PreviousLocationProvider';
import { setDocumentTitle } from '../../../util';

class SurveyQuestions extends Component {
  constructor(props) {
    super(props);

    this.changePreviewLanguage = this.changePreviewLanguage.bind(this);
    this.previousLocation = this.props.previousLocation;
    this.state = {
      previewLanguage: props.lang,
      surveyParts: []
    };
  }

  async componentDidMount() {
    const {
      surveyOptions,
      dispatchSetTaskPending,
      dispatchSetTaskFulfilled,
      dispatchAddErrorMessage
    } = this.props;

    dispatchSetTaskPending();
    try {
      const [schema, extraSurveyPart] = await Promise.all([
        getSurveySchema(surveyOptions.schemaId), this.getExtraSurveyPart()
      ]);
      const surveyParts = [...schema.surveySchemaParts, ...(schema.extraSurveyPart ? [schema.extraSurveyPart] : [])];
      if (extraSurveyPart) {
        surveyParts.push(extraSurveyPart);
      }

      this.setState({ surveyParts });
    } catch (e) {
      dispatchAddErrorMessage(e);
    } finally {
      dispatchSetTaskFulfilled();
    }
  }

  async getExtraSurveyPart() {
    const { surveyOptions } = this.props;
    const extraSurveyPartId = surveyOptions.extraSurveyPart && surveyOptions.extraSurveyPart.id;
    if (extraSurveyPartId) {
      return getExtraSurveyPart(extraSurveyPartId);
    }
    return null;
  }

  changePreviewLanguage(previewLanguage) {
    this.setState({ previewLanguage });
  }

  render() {
    const { translate: t } = this.props;
    const { previewLanguage, surveyParts } = this.state;
    setDocumentTitle(t('startSurvey.viewQuestions.title'));

    return (
      <div className="page-container">
        <h1>{t('startSurvey.viewQuestions.title')}</h1>

        <PreviewLanguageSelector
          previewLang={previewLanguage}
          onLanguageSelect={this.changePreviewLanguage}
        />
        <div>
          {surveyParts.map((part, idx) => (
            <SchemaPartQuestionsPreview
              key={part.id}
              schemaPart={part}
              partNumber={idx + 1}
              lang={previewLanguage}
              translate={t}
            />
          ))}
        </div>

        <div className={styles.actions}>
          <Link className="button button--action" to={this.previousLocation}>
            {t('common.back')}
          </Link>
        </div>
      </div>
    );
  }
}

SurveyQuestions.propTypes = {
  surveyOptions: surveyOptionsType.isRequired,
  dispatchSetTaskPending: func.isRequired,
  dispatchSetTaskFulfilled: func.isRequired,
  dispatchAddErrorMessage: func.isRequired,
  previousLocation: shape({
    pathname: string
  }).isRequired,
  ...langType
};

const mapStateToProps = ({ survey }) => ({
  surveyOptions: survey.surveyOptions
});

const mapDispatchToProps = (dispatch) => ({
  dispatchSetTaskPending: () => dispatch(setTaskPending()),
  dispatchSetTaskFulfilled: () => dispatch(setTaskFulfilled()),
  dispatchAddErrorMessage: (err) => dispatch(addErrorMessageAction(err))
});

export default withRouter(withLang(withPreviousLocation(
  connect(mapStateToProps, mapDispatchToProps)(SurveyQuestions)
)));
